import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "ring"];

  connect() {
    this.updateProgress = this.updateProgress.bind(this);
    this.toggleVisibility = 160;

    window.addEventListener("scroll", this.updateProgress, { passive: true });
    window.addEventListener("resize", this.updateProgress);
    document.addEventListener("turbo:load", this.updateProgress);

    this.updateProgress();
  }

  disconnect() {
    window.removeEventListener("scroll", this.updateProgress);
    window.removeEventListener("resize", this.updateProgress);
    document.removeEventListener("turbo:load", this.updateProgress);
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  updateProgress() {
    const scrollTop = window.scrollY || window.pageYOffset || 0;
    const scrollHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const progress =
      scrollHeight > 0 ? Math.min((scrollTop / scrollHeight) * 100, 100) : 0;

    this.buttonTarget.classList.toggle(
      "is-visible",
      scrollTop > this.toggleVisibility,
    );
    this.ringTarget.style.setProperty("--scroll-progress", `${progress}%`);
  }
}
